(() => {
  if (window.__eidoViewTransitions) return;
  window.__eidoViewTransitions = true;
  const root = document.documentElement;
  const preference = matchMedia('(prefers-reduced-motion: reduce)');
  const key = 'eido:product-transition:v1';
  let active;
  const reduced = () => preference.matches || root.dataset.eidoA11yReduceMotion === 'true';
  const clear = () => document.querySelectorAll('[data-eido-transition-image]').forEach(el => { el.removeAttribute('data-eido-transition-image'); el.removeAttribute('data-eido-transition-url'); });
  const storage = (value) => {
    try {
      if (value === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      if (value === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(value));
      return true;
    } catch (_) { return null; }
  };
  const mediaKey = (src) => {
    try { return new URL(src, location.href).pathname.split(/\/(?:files|products)\//).pop(); }
    catch (_) { return ''; }
  };
  const track = (transition) => {
    if (active && active !== transition) active.skipTransition();
    active = transition;
    transition.ready.catch(() => {});
    transition.updateCallbackDone?.catch(() => {});
    transition.finished.catch(() => {}).finally(() => {
      if (active === transition) { active = undefined; clear(); }
    });
  };
  const skipMotion = () => { if (reduced()) { active?.skipTransition(); clear(); storage(null); } };
  const interrupt = () => active?.skipTransition();
  document.addEventListener('pointerdown', interrupt, { passive: true, capture: true });
  document.addEventListener('keydown', interrupt, { capture: true });
  document.addEventListener('dialog:open', interrupt, { capture: true });
  document.addEventListener('eido:overlay-open', interrupt);
  preference.addEventListener('change', skipMotion);
  document.addEventListener('eido:a11y-change', skipMotion);
  window.addEventListener('pageswap', event => {
    const transition = event.viewTransition;
    storage(null);
    if (!transition) { clear(); return; }
    track(transition);
    if (reduced()) { transition.skipTransition(); clear(); return; }
    const image = document.querySelector('[data-eido-transition-image]');
    const destination = event.activation?.entry?.url;
    const card = image?.closest('product-card-link');
    if (image && card && destination && root.dataset.productTransition === 'true') {
      const target = new URL(destination);
      const expected = new URL(image.dataset.eidoTransitionUrl, location.href);
      if (target.href === expected.href && target.origin === location.origin && storage({
        to: target.href, from: location.href, created: Date.now(),
        product: card.dataset.productId, media: mediaKey(image.currentSrc || image.src),
      })) return;
    }
    clear();
    if (root.dataset.pageTransitionEnabled !== 'true') transition.skipTransition();
  });
  window.addEventListener('pagereveal', event => {
    const info = storage();
    storage(null);
    clear();
    const transition = event.viewTransition;
    if (!transition) return;
    track(transition);
    if (reduced()) { transition.skipTransition(); return; }
    const main = document.getElementById('MainContent');
    if (info && info.to === location.href && Date.now() - info.created < 10000 &&
        main?.dataset.productId === info.product && root.dataset.productTransition === 'true') {
      // Match only the first visible product image, not a later gallery frame.
      const image = [...main.querySelectorAll('media-gallery img[transitionToProduct], media-gallery .product-media img')]
        .find(img => img.getClientRects().length && getComputedStyle(img).visibility !== 'hidden');
      if (image?.complete && image.naturalWidth && mediaKey(image.currentSrc || image.src) === info.media) {
        image.setAttribute('data-eido-transition-image', '');
        return;
      }
    }
    // A mismatched image cannot safely morph; let the page crossfade stand alone.
    if (root.dataset.pageTransitionEnabled !== 'true') transition.skipTransition();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) { clear(); storage(null); } });
})();
